export default __webpack_public_path__ + "static/media/tweet1.dc153c3b.jpg";